import { crc16 } from './crc16';

export type PixValidationResult = { kind: 'valid'; normalized: string } | { kind: 'invalid' };

const EMV_PREFIX = '000201';
const CRC_LENGTH = 4;

export function validatePix(rawInput: string): PixValidationResult {
  const normalized = rawInput.trim();

  if (!normalized.startsWith(EMV_PREFIX) || normalized.length <= CRC_LENGTH) {
    return { kind: 'invalid' };
  }

  const payloadWithoutCrc = normalized.slice(0, -CRC_LENGTH);
  const expectedCrc = normalized.slice(-CRC_LENGTH).toUpperCase();

  if (crc16(payloadWithoutCrc) !== expectedCrc) {
    return { kind: 'invalid' };
  }

  return { kind: 'valid', normalized };
}
